import { Component, Injector, OnDestroy, Input } from '@angular/core';
import { BaseFormComponent } from '../base-form.component';

@Component({
  moduleId: module.id,
  selector: 'custom-height',
  templateUrl: './custom-height.component.html',
})
export class CustomHeightComponent extends BaseFormComponent {
  heightFeetProperty: string;
  heightInchesProperty: string;

  constructor(protected injector: Injector) {
    super(injector);

    this.questionItem = this.injector.get('questionItem');
    this.heightFeetProperty = this.questionItem.prop + '.heightFeet';
    this.heightInchesProperty = this.questionItem.prop + '.heightInches';
  }

  updateFromModel() {}

  resetValue() {}
}
